/*
  section-reveal.js
  Marks below-the-fold home page sections so the browser can skip rendering them
  until they are needed, and fades them in on scroll.

  Why this helps: with ~20 sections of product cards, the browser otherwise has
  to style, lay out and paint every card at load. content-visibility defers that
  work until a section approaches the viewport.
*/
(function () {
  // Sections above this index render immediately (hero area).
  var EAGER_COUNT = 2;
  // Start rendering / revealing this far before the section enters view.
  var ROOT_MARGIN = '600px 0px';

  function getSections() {
    var main = document.getElementById('MainContent') || document.body;
    return Array.prototype.slice.call(main.children).filter(function (el) {
      return el.classList && el.classList.contains('shopify-section');
    });
  }

  function reveal(el) {
    el.classList.add('sr-visible');
    // Once shown, drop the containment so nothing can be clipped or re-hidden
    el.classList.remove('sr-defer');
    el.classList.add('sr-done');
  }

  function init() {
    var sections = getSections();
    if (!sections.length) return;

    var lazy = sections.slice(EAGER_COUNT);
    if (!lazy.length) return;

    var supportsIO = 'IntersectionObserver' in window;

    lazy.forEach(function (el) {
      if (el.dataset.srBound) return;
      el.dataset.srBound = '1';
      el.classList.add('sr-defer', 'sr-reveal');
      if (!supportsIO) reveal(el);
    });

    if (!supportsIO) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: ROOT_MARGIN, threshold: 0 }
    );

    lazy.forEach(function (el) {
      io.observe(el);
    });

    // Safety net: if the visitor never scrolls but the page is idle, reveal the
    // next couple of sections so nothing sits permanently blank.
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
    idle(function () {
      lazy.slice(0, 2).forEach(function (el) {
        if (!el.classList.contains('sr-visible')) reveal(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
